'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chatMessageReceived = undefined;

var _defaultMessageReceived = require('../../actions/defaultMessageReceived');

var _dismissTypingIndicator = require('../../typing-indicators/actions/dismissTypingIndicator');

var _resolveAttachmentsForMessage = require('../../resolved-attachments/actions/resolveAttachmentsForMessage');

var chatMessageReceived = exports.chatMessageReceived = function chatMessageReceived(message, channel, threadId) {
  return function (dispatch) {
    dispatch((0, _dismissTypingIndicator.dismissTypingIndicator)(message, threadId));
    dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel, threadId));
    dispatch((0, _resolveAttachmentsForMessage.resolveAttachmentsForMessage)({ message: message, threadId: threadId }));
  };
};